import { Injectable } from '@angular/core';
import { BaseStateService } from '../base-state-service/base-state.service';
import { OverallStoreState } from '../models/overall-store';

@Injectable({
    providedIn: 'root'
})
export class OverallStateService extends BaseStateService<OverallStoreState> {

    constructor() {
        super();
        this.initialState();
    }

    initialState(): void {
        const initialState: OverallStoreState = {
            allData: undefined,
        };
        this.setState(initialState, 'INIT_STATE');
    }
}
